import "./LoaderAlert.css";

const Loader = () => {
  return (
    <div className="boxloaderAlert">
      <div className="loaderAlert">
        Cargando
        <span></span>
      </div>
    </div>
  );
};

export default Loader;
